<div class="content-wrapper">
    <div class="card">
      <div class="card-body" >
        <div class="row ">
            <div class="col-md-12">
                <h4 class="title">Dynamic Data</h4>
            </div>
        </div>
        <div class="field-separator"></div>
            <div class="row">
                <div class="col-md-2">
                    <div class="form-group">
                        <select class="form-control" name="supportType" [(ngModel)]="supportType" (change)="getSupports()">
                            <option value="caseTypes">Case Types</option>
                            <option value="caseTitles">Case Titles</option>
                            <option value="caseStatus">Case Status</option>
                            <option value="outstandingDocuments">Outstanding Documents</option>
                            <option value="categories">Categories</option>
                            <option value="practices">Area of Practices</option>
                            <option value="expenceTypes">Expence Types</option>
                            <option value="additionalWorks">Additional Work</option>
                            <option value="documentTypes">Document Types</option>
                            <option value="fundingTypes">Funding Types</option>
                            <option value="methops">Payment Methods</option>
                            <option value="userTypes">User Types</option>
                            <option value="designation">Designations</option>
                            <option value="titles">Titles </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <form #supportForm="ngForm">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <input class="form-control" type="text" name="supportName" id="supportName" placeholder="Details" [(ngModel)]="supportName" required>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <button class="btn btn-primary mr-4" [disabled]="supportForm.invalid" (click)="saveSupportForm()">Save Now</button>
                                <button class="btn btn-danger pull-right" (click)="clearForm()">Clear Form</button>
                            </div>
                        </div>
                    </form>
                    
                </div>
            </div>
            <div class="field-separator"></div>
            <div *ngIf="supports">
                <ul class="my-list">
                    <li *ngFor="let support of supports">{{support.name}} <span (click)="editSupport(support)"><i class="icon-pencil btn-outline-primary"></i></span></li>
                </ul>
                
            </div>
            <app-nodata *ngIf="!supports"></app-nodata>

        </div>
    </div>
</div>